'use client';
import BackgroundImage from '@components/background-image/BackgroundImage';
import Bgr1MobNew from '@images/renders/bg_images/bg_1_mob_new.webp';
import Bgr1 from '@images/renders/bg_images/bgr_1_new.webp';
import { MAIN_TWO_BLOCKS_CONTENT, PROMO_MAIN_FORMA_35027 } from '@lib/flags';
import { useDeviceScreen } from '@lib/layouts/DeviceScreenProvider';
import { isLoadingSelector } from '@lib/store/slices/ComponentsSlice';
import dynamic from 'next/dynamic';
import { memo, useLayoutEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PromoBannerSlider from 'src/app/components/promo-banner-slider/PromoBannerSlider';
import style from './MainScreen.module.scss';

const AnimateLines = dynamic(() => import('@components/animate-lines/AnimateLines'));
const AnimatedText = dynamic(() => import('@components/animated-text/AnimatedText'));
const SmallDynamicBanner = dynamic(() => import('../small-dynamic-banner/SmallDynamicBanner'));

const MainScreen = memo(({ promoCardsData, contentData, heroImageDesktop, heroImageMobile }) => {
  const [toggle, setToggle] = useState(false);
  const [toggle2, setToggle2] = useState(false);

  const firstContainerRef = useRef();

  const { deviceType, isMobile } = useDeviceScreen();

  const isLoading = useSelector(isLoadingSelector);

  const promoCards = promoCardsData?.items;

  const visiblePromoCards = promoCards?.filter(item => item?.hidden === false);

  const isServerContent = MAIN_TWO_BLOCKS_CONTENT && contentData?.items?.length === 6;

  useLayoutEffect(() => {
    let timerIdOne;
    let timerIdTwo;

    if (isLoading) {
      timerIdOne = setTimeout(() => setToggle(true), 200);
      timerIdTwo = setTimeout(() => setToggle2(true), 1000);
    }

    return () => {
      if (timerIdOne || timerIdTwo) {
        clearTimeout(timerIdOne);
        clearTimeout(timerIdTwo);
      }
    };
  }, [isLoading]);

  return (
    <div data-scroll className={style.firstScreenContainer} ref={firstContainerRef}>
      <BackgroundImage
        first={true}
        toggle={toggle}
        src={isServerContent ? heroImageDesktop || Bgr1 : Bgr1}
        src375={isServerContent ? heroImageMobile || Bgr1MobNew : Bgr1MobNew}
        name='bgr_1'
        loading='eager'
        decoding='sync'
        fetchPriority='high'
        priority
        className={style.firstScreenBackground}
      />
      {deviceType && (
        <div className={style.firstScreenSvg}>
          <AnimateLines id={!isMobile ? 'vector_1' : 'vector_1_mob'} className={style.svgClass} toggle={toggle} />
        </div>
      )}
      <div className={style.firstScreenAnimText}>
        <AnimatedText
          id={!isMobile ? 'text_2' : 'text_1_mob'}
          className={style.svgTextClass}
          toggle={toggle}
          style={{ display: toggle2 && deviceType ? 'initial' : 'none' }}
          title={contentData?.name ?? []}
        />
      </div>
      {PROMO_MAIN_FORMA_35027 && <PromoBannerSlider promoCards={visiblePromoCards} />}
      {!PROMO_MAIN_FORMA_35027 && <SmallDynamicBanner promoCards={visiblePromoCards} />}
    </div>
  );
});

export default MainScreen;
